import { render } from "./AuthorQuotes.vue?vue&type=template&id=777baf66&scoped=true&ts=true"
import script from "./AuthorQuotes.vue?vue&type=script&lang=ts"
export * from "./AuthorQuotes.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-777baf66"]])

export default __exports__